// src/app/views/coming-soon/ComingSoon.tsx

import React, { useEffect, useState } from 'react';
import styles from './ComingSoon.module.scss';

const ComingSoon: React.FC = () => {
  // Copy for the start text using template literals
  const [startText, setStartText] = useState(
    `Press the power button <br /> or space bar to turn on`,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      if (event.matches) {
        setStartText(`Press the power button <br /> or tap to turn on`);
      } else {
        setStartText(`Press the power button <br /> or space bar to turn on`);
      }
    };

    // Set initial value based on media query
    if (mediaQuery.matches) {
      setStartText(`Press the power button <br /> or touch to turn on`);
    }

    // Listen for changes in viewport width
    mediaQuery.addEventListener('change', handleMediaQueryChange);

    // Clean up event listener on component unmount
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, []);

  // Helper to render copy with <br /> tags without using dangerouslySetInnerHTML
  const renderCopy = (copy: string) => {
    return copy.split('<br />').map((text, idx, arr) => (
      <React.Fragment key={idx}>
        {text}
        {idx < arr.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className={styles['coming-soon__container']}>
      {/* Overlays */}
      <div className={styles['coming-soon__overlay']}></div>
      <div
        className={`${styles['coming-soon__overlay']} ${styles['coming-soon__overlay--glitch']}`}
      ></div>

      {/* Version Information */}
      <div
        className={styles['coming-soon__version']}
        data-text={`// v1.25 CRYPTO BROS SYNDICATE 2K24`}
      >
        {`// ChadOS v0.69 ChadAI Foundation`}
      </div>

      {/* Start Text */}
      <div className={styles['coming-soon__start-text']}>
        {renderCopy(startText)}
      </div>

      {/* Backed By Logos */}
      <div className={styles['coming-soon__backed-by']} data-text='BACKED BY:'>
        <div
          className={styles['coming-soon__backed-by-text']}
          data-text='BACKED BY:'
        >
          BACKED BY:
        </div>

        {/* First Row of Logos */}
        <div
          className={`${styles['coming-soon__logos']} ${styles['coming-soon__logos--first-row']}`}
        >
          <div>
            <img src='/logo/chadscale.webp' alt='Chadscale' />
          </div>
          <div>
            <img src='/logo/multichad-capital.webp' alt='Multichad Capital' />
          </div>
          <div>
            <img src='/logo/chadbase-ventures.webp' alt='Chadbase Ventures' />
          </div>
        </div>

        {/* Second Row of Logos */}
        <div
          className={`${styles['coming-soon__logos']} ${styles['coming-soon__logos--second-row']}`}
        >
          <div>
            <img src='/logo/69-crypto.webp' alt='A69z Crypto' />
          </div>
          <div>
            <img src='/logo/polychad-capital.webp' alt='Polychad Capital' />
          </div>
          <div>
            <img
              src='/logo/digital-currency-chad.webp'
              alt='Digital Currency Chads'
            />
          </div>
          <div>
            <img src='/logo/3-chads-capital.webp' alt='3 Chads Capital' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
